<template>
    <div>
        <h3>
            <span>{{ heading }}</span><font-awesome-icon
                v-if="icon"
                :icon="icon"
                class="ml-2" />
        </h3>
        <div><slot /></div>
    </div>
</template>

<script>
export default {
    name: "EventEntryDetailsElement",
    inject: ['setHasContentTrue'],
    props: {
        heading: {
            type: String,
            required: true
        },
        icon: {
            type: String
        }
    },
    mounted() {
        this.setHasContentTrue()
    }
}
</script>

<style lang="scss" scoped>
h3 {
    font-weight: normal;
}
h3 > svg {
    color: $gray-700;
}
</style>
